<template>
  <div style="font-family: Raleway, sans-serif; padding: 10px 0;">
    <table justify="center"
      style="width: 100% !important; font-size: 10px !important; font-family: 'Roboto-Regular'; border-collapse: collapse;"
      border="1"
      class="mb-10"
      cellspacing="0"
      cellpadding="6"
      id="basic">
      <thead>
        <tr :class="['header', 'naslov']"
          style="text-align: center">
          <th colspan="2" style="padding: 8px; font-size: 11px;">Osnovni podaci</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="font-weight-bold" style="padding: 6px; width: 40%;">Broj primke</td>
          <td style="padding: 6px;">{{ interniBrojPrimke }}</td>
        </tr>
        <tr>
          <td class="font-weight-bold" style="padding: 6px;">Firma</td>
          <td style="padding: 6px;">{{ company }}</td>
        </tr>
        <tr>
          <td class="font-weight-bold" style="padding: 6px;">Prodajno mjesto</td>
          <td style="padding: 6px;">{{ location }}</td>
        </tr>
        <tr>
          <td class="font-weight-bold" style="padding: 6px;">Skladište</td>
          <td style="padding: 6px;">{{ warehouseName }}</td>
        </tr>
        <tr>
          <td class="font-weight-bold" style="padding: 6px;">Dobavljač</td>
          <td style="padding: 6px;">{{ dobavljac }}</td>
        </tr>
        <tr>
          <td class="font-weight-bold" style="padding: 6px;">Način plaćanja</td>
          <td style="padding: 6px;">{{ fobDescription }}</td>
        </tr>
        <tr>
          <td class="font-weight-bold" style="padding: 6px;">Datum</td>
          <td style="padding: 6px;">{{ formatDate(datumKreiranja) }}</td>
        </tr>
        <tr>
          <td class="font-weight-bold" style="padding: 6px;">Broj temeljnice</td>
          <td style="padding: 6px;">{{ deliveryNumber }}</td>
        </tr>
      </tbody>
    </table>

    <table justify="center"
      style="width: 100% !important; border-collapse: collapse; font-size: 10px;"
      border="1"
      cellspacing="0"
      cellpadding="6"
      id="tableExtra"
      v-if="showTableData && stavke.length > 0">
      <thead>
        <tr :class="['header', 'naslov']"
          style="text-align: center">
          <th colspan="16" style="padding: 8px; font-size: 11px;">Primka - Artikli</th>
        </tr>
      </thead>
      <tbody>
        <tr :class="['header', 'naslov']"
          style="font-weight: bold; text-align: left; font-size: 10px;">
          <th style="padding: 6px; min-width: 100px;">Naziv</th>
          <th style="padding: 6px; min-width: 35px;">J.mj.</th>
          <th style="padding: 6px; min-width: 50px;">Količina</th>
          <th style="padding: 6px; min-width: 55px;">Nab.cij.</th>
          <th style="padding: 6px; min-width: 55px;">Iznos</th>
          <th style="padding: 6px; min-width: 50px;">Rabat%</th>
          <th style="padding: 6px; min-width: 55px;">Rabat</th>
          <th style="padding: 6px; min-width: 55px;">Nab.vrij.</th>
          <th style="padding: 6px; min-width: 50px;">Marža%</th>
          <th style="padding: 6px; min-width: 55px;">Marža</th>
          <th style="padding: 6px; min-width: 55px;">Cijena</th>
          <th style="padding: 6px; min-width: 55px;">Iznos</th>
          <th style="padding: 6px; min-width: 50px;">PDV%</th>
          <th style="padding: 6px; min-width: 55px;">PDV</th>
          <th style="padding: 6px; min-width: 60px;">Izn.s PDV</th>
          <th style="padding: 6px; min-width: 60px;">Cij.(s PDV)</th>
        </tr>
        <tr v-for="i in regularStavke"
          :key="i.id"
          style="font-size: 10px;">
          <!-- NAZIV -->
          <td style="text-align: left; padding: 6px;">{{ i.item.item.name }}</td>

          <!-- J. mj. -->
          <td style="text-align: left; padding: 6px;">{{ i.item.warehouse_data.received_amount_measure_unit }}</td>

          <!-- KOLICINA -->
          <td style="text-align: right; padding: 6px;">{{ getKolicina(i) }}</td>

          <!-- NABAVNA CIJENA -->
          <td style="text-align: right; padding: 6px;">{{ getNabavnaCijena(i) }}</td>

          <!-- IZNOS -->
          <td style="text-align: right; padding: 6px;">{{ getIznos(i) }}</td>

          <!-- RABAT % -->
          <td style="text-align: right; padding: 6px;">{{ getRabatStopa(i) }}</td>

          <!-- RABAT IZNOS -->
          <td style="text-align: right; padding: 6px;">{{ getRabatIznos(i) }}</td>

          <!-- NABAVNA VRIJ -->
          <td style="text-align: right; padding: 6px;">{{ getNabavnaVrijednost(i) }}</td>

          <!-- MARZA % -->
          <td style="text-align: right; padding: 6px;">{{ getMarza(i) }}</td>

          <!-- MARZA IZNOS -->
          <td style="text-align: right; padding: 6px;">{{ getMarzaIznos(i) }}</td>

          <!-- CIJENA -->
          <td style="text-align: right; padding: 6px;">{{ getCijena(i) }}</td>

          <!-- IZNOS -->
          <td style="text-align: right; padding: 6px;">{{ getIznos2(i) }}</td>

          <!-- PDV % -->
          <td style="text-align: right; padding: 6px;">{{ getPdvStopa(i) }}</td>

          <!-- PDV IZNOS -->
          <td style="text-align: right; padding: 6px;">{{ getPdvIznos(i) }}</td>

          <!-- IZNOS S PDV -->
          <td style="text-align: right; padding: 6px;">{{ getIznosSPdv(i) }}</td>

          <!-- CIJENA S PDV -->
          <td style="text-align: right; padding: 6px;">{{ getCijenaSPdv(i) }}</td>
        </tr>

        <tr class="divider-line">
          <td colspan="16"></td>
        </tr>

        <!-- SVEUKUPNO redak (samo regularni artikli) -->
        <tr class="summary-row" style="font-size: 10px;">
          <td style="padding: 6px; font-weight: bold;">SVEUKUPNO</td>
          <td style="padding: 6px;"></td>
          <td style="text-align: right; padding: 6px; font-weight: bold;">{{ zbrojiKolicine() }}</td>
          <td style="padding: 6px;"></td>
          <td style="text-align: right; padding: 6px; font-weight: bold;">{{ zbrojiIznos() }}</td>
          <td style="padding: 6px;"></td>
          <td style="text-align: right; padding: 6px; font-weight: bold;">{{ zbrojiRabat() }}</td>
          <td style="text-align: right; padding: 6px; font-weight: bold;">{{ zbrojiNabavnuVrijednost() }}</td>
          <td style="padding: 6px;"></td>
          <td style="text-align: right; padding: 6px; font-weight: bold;">{{ zbrojiMarzu() }}</td>
          <td style="padding: 6px;"></td>
          <td style="text-align: right; padding: 6px; font-weight: bold;">{{ zbrojiIznos2() }}</td>
          <td style="padding: 6px;"></td>
          <td style="text-align: right; padding: 6px; font-weight: bold;">{{ zbrojiPdvIznos() }}</td>
          <td style="text-align: right; padding: 6px; font-weight: bold;">{{ zbrojiIznosSPdv() }}</td>
          <td style="padding: 6px;"></td>
        </tr>

        <!-- Povratna naknada redak -->
        <tr v-if="povratnaNaknadaStavke.length > 0"
          style="font-size: 10px; background-color: #f5f5f5;">
          <!-- NAZIV -->
          <td style="text-align: left; padding: 6px; font-weight: bold;" colspan="10">Povratna naknada</td>

          <!-- CIJENA -->
          <td style="text-align: right; padding: 6px;"></td>

          <!-- IZNOS - ukupna povratna naknada -->
          <td style="text-align: right; padding: 6px; font-weight: bold;">{{ getUkupnaPovratnaNaknada() }}</td>

          <!-- PDV % -->
          <td style="text-align: right; padding: 6px;"></td>

          <!-- PDV IZNOS -->
          <td style="text-align: right; padding: 6px;"></td>

          <!-- IZNOS S PDV -->
          <td style="text-align: right; padding: 6px;"></td>

          <!-- CIJENA S PDV -->
          <td style="text-align: right; padding: 6px;"></td>
        </tr>

        <tr class="divider-line">
          <td colspan="16"></td>
        </tr>

        <!-- TOTAL redak (SVEUKUPNO + Povratna naknada) -->
        <tr v-if="povratnaNaknadaStavke.length > 0" class="summary-row" style="font-size: 10px; font-weight: bold;">
          <td style="padding: 6px; font-weight: bold; border-top: 2px solid #000;">TOTAL</td>
          <td style="padding: 6px; border-top: 2px solid #000;"></td>
          <td style="text-align: right; padding: 6px; font-weight: bold; border-top: 2px solid #000;">{{ zbrojiKolicine() }}</td>
          <td style="padding: 6px; border-top: 2px solid #000;"></td>
          <td style="text-align: right; padding: 6px; font-weight: bold; border-top: 2px solid #000;">{{ zbrojiIznos() }}</td>
          <td style="padding: 6px; border-top: 2px solid #000;"></td>
          <td style="text-align: right; padding: 6px; font-weight: bold; border-top: 2px solid #000;">{{ zbrojiRabat() }}</td>
          <td style="text-align: right; padding: 6px; font-weight: bold; border-top: 2px solid #000;">{{ zbrojiNabavnuVrijednost() }}</td>
          <td style="padding: 6px; border-top: 2px solid #000;"></td>
          <td style="text-align: right; padding: 6px; font-weight: bold; border-top: 2px solid #000;">{{ zbrojiMarzu() }}</td>
          <td style="padding: 6px; border-top: 2px solid #000;"></td>
          <td style="text-align: right; padding: 6px; font-weight: bold; border-top: 2px solid #000;">{{ totalIznos2() }}</td>
          <td style="padding: 6px; border-top: 2px solid #000;"></td>
          <td style="text-align: right; padding: 6px; font-weight: bold; border-top: 2px solid #000;">{{ zbrojiPdvIznos() }}</td>
          <td style="text-align: right; padding: 6px; font-weight: bold; border-top: 2px solid #000;">{{ totalIznosSPdv() }}</td>
          <td style="padding: 6px; border-top: 2px solid #000;"></td>
        </tr>

        <tr v-if="false" style="height: 15px;">
          <td colspan="16" style="border: none; font-size: 1px;"></td>
        </tr>

        <tr v-if="false" :class="['header', 'naslov']">
          <td colspan="16" style="text-align: left; padding: 8px; font-weight: bold; font-size: 11px;">Rekapitulacija po stopama PDV-a</td>
        </tr>

        <tr v-if="false" :class="['header', 'naslov']" style="font-size: 10px;">
          <th style="padding: 6px; width: 15%;">Vrsta poreza</th>
          <th style="padding: 6px; width: 10%;">T. broj</th>
          <th style="padding: 6px; width: 10%;">PDV %</th>
          <th style="padding: 6px; width: 20%;">Iznos</th>
          <th style="padding: 6px; width: 20%;">PDV iznos</th>
          <th style="padding: 6px; width: 20%;">Iznos s PDV</th>
          <th colspan="10" style="padding: 6px;"></th>
        </tr>
        <tr v-if="false" v-for="(tax, index) in taxes"
          :key="'tax-' + index"
          style="font-size: 10px;">
          <td style="padding: 6px;">{{ tax.vrsta_poreza }}</td>
          <td style="padding: 6px;">{{ tax.t_broj }}</td>
          <td style="text-align: right; padding: 6px;">{{ formatCurrency(tax.pdv_stopa / 100, 1) }}%</td>
          <td style="text-align: right; padding: 6px;">{{ formatCurrency(tax.iznos / 100, 1) }}</td>
          <td style="text-align: right; padding: 6px;">{{ formatCurrency(tax.pdv_iznos / 100, 1) }}</td>
          <td style="text-align: right; padding: 6px;">{{ formatCurrency(tax.iznos_s_pdv / 100, 1) }}</td>
          <td colspan="10" style="padding: 6px;"></td>
        </tr>

      </tbody>
    </table>

    <!-- Povratna naknada sekcija - sada integrirano u glavnu tablicu -->
    <div v-if="false"
      style="font-family: Raleway, sans-serif; padding: 10px 0;">
      <table justify="center"
        style="width: 100% !important; font-size: 10px; font-family: 'Roboto-Regular'; border-collapse: collapse;"
        border="1"
        cellspacing="0"
        cellpadding="6"
        id="tablePovratnaNaknada">
        <thead>
          <tr :class="['header', 'naslov']"
            style="text-align: center">
            <th colspan="4" style="padding: 8px; font-size: 11px;">Povratna naknada</th>
          </tr>
        </thead>
        <tbody>
          <tr :class="['header', 'naslov']"
            style="font-weight: bold; text-align: left; font-size: 10px;">
            <th style="padding: 6px; width: 40%;">Naziv</th>
            <th style="padding: 6px; width: 20%;">Količina</th>
            <th style="padding: 6px; width: 20%;">Cijena po jedinici</th>
            <th style="padding: 6px; width: 20%;">Ukupno</th>
          </tr>
          <tr v-for="i in povratnaNaknadaStavke"
            :key="'pn-' + i.id"
            style="font-size: 10px;">
            <td style="padding: 6px;">{{ getPovratnaNaknadaNaziv(i) }}</td>
            <td style="text-align: right; padding: 6px;">{{ getKolicina(i) }}</td>
            <td style="text-align: right; padding: 6px;">{{ getCijena(i) }}</td>
            <td style="text-align: right; padding: 6px;">{{ getIznos(i) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  components: {
  },
  inject: ['showMsgBox', 'showLoader', 'hideLoader', 'showAlert'],
  props: {
    transferData: Array,
    stavke: Array,
    showTableData: Boolean,
    viewType: String,
    warehouseName: String,
    dobavljac: String,
    fobDescription: String,
    datumKreiranja: Number,
    deliveryNumber: String,
    interniBrojPrimke: String,
    ukupnoBezPdv: Number,
    inputTaxTotal: Number,
    ukupnoBrutto: Number,
    selectedDeliveryNote: Object,
    company: String,
    location: String
  },
  data: () => ({
    currency: 'EUR',
    taxes: []
  }),
  computed: {
    regularStavke () {
      return this.stavke.filter(i => !this.isPovratnaNaknada(i))
    },
    povratnaNaknadaStavke () {
      return this.stavke.filter(i => this.isPovratnaNaknada(i))
    }
  },
  async mounted () {
    this.setTaxes()
  },
  methods: {
    formatDate: function (date) {
      if (date === '') {
        return ''
      }
      date = new Date(date * 1000)

      return moment(date).format('DD.MM.YYYY')
    },
    setTaxes () {
      const taxSummary = new Map()

      this.stavke.forEach(i => {
        // Preskači povratnu naknadu za PDV rekapitulaciju
        if (this.isPovratnaNaknada(i)) {
          return
        }

        // Provjeri postoje li potrebni podaci da se izbjegnu greške
        if (i && i.item && i.item.kalkulacija && i.item.kalkulacija.cijena) {
          const kalkulacija = i.item.kalkulacija
          const cijena = kalkulacija.cijena
          const stopa = cijena.pdv_stopa // npr. 2500 za 25%

          // Dohvati vrijednosti, koristi 0 ako su undefined/null
          const iznos = cijena.ukupna_prodajna_cijena_bez_pdv || 0
          const pdvIznos = cijena.ukupni_pdv || 0
          const iznosSPdv = cijena.ukupna_prodajna_cijena_sa_pdv || 0
          const povNaknada = 0 // Fiksno 0 prema zahtjevu
          const ukupno = cijena.ukupna_prodajna_cijena_sa_pdv || 0 // Ukupno je isto kao iznos s PDV

          if (taxSummary.has(stopa)) {
            // Ažuriraj postojeći unos za ovu stopu
            const current = taxSummary.get(stopa)
            current.iznos += iznos
            current.pdv_iznos += pdvIznos
            current.iznos_s_pdv += iznosSPdv
            current.pov_naknada += povNaknada // Ostat će 0
            current.ukupno += ukupno
          } else {
            // Kreiraj novi unos za ovu stopu
            taxSummary.set(stopa, {
              pdv_stopa: stopa,
              iznos: iznos,
              pdv_iznos: pdvIznos,
              iznos_s_pdv: iznosSPdv,
              pov_naknada: povNaknada,
              ukupno: ukupno,
              // Dodaj polja za prikaz u tablici
              vrsta_poreza: 'PDV', // Pretpostavka
              t_broj: '' // Placeholder, možeš dodati logiku ako je potrebno
            })
          }
        } else {
          console.warn('Preskačem stavku zbog nedostajućih podataka kalkulacije ili cijene:', i)
        }
      })

      this.taxes = Array.from(taxSummary.values())

      this.taxes.sort((a, b) => a.pdv_stopa - b.pdv_stopa)

      this.taxes.push()
    },
    zbrojiKolicine () {
      var kolicina = 0
      this.stavke.forEach(i => {
        if (!this.isPovratnaNaknada(i)) {
          kolicina += (i.item && i.item.kalkulacija && i.item.kalkulacija.kolicina) || 0
        }
      })

      if (this.viewType === 'pdf') {
        return this.formatCurrency(kolicina / 1000, 1)
      } else {
        return kolicina / 1000
      }
    },

    zbrojiIznos () {
      var iznos = 0
      this.stavke.forEach(i => {
        if (!this.isPovratnaNaknada(i)) {
          iznos += (i.item && i.item.kalkulacija && i.item.kalkulacija.nabavna_cijena && i.item.kalkulacija.nabavna_cijena.iznos) || 0
        }
      })

      if (this.viewType === 'pdf') {
        return this.formatCurrency(iznos / 100, 1)
      } else {
        return iznos / 100
      }
    },

    zbrojiRabat () {
      var rabat = 0
      this.stavke.forEach(i => {
        if (!this.isPovratnaNaknada(i)) {
          rabat += (i.item && i.item.kalkulacija && i.item.kalkulacija.nabavna_cijena && i.item.kalkulacija.nabavna_cijena.rabat_iznos) || 0
        }
      })

      if (this.viewType === 'pdf') {
        return this.formatCurrency(rabat / 100, 1)
      } else {
        return rabat / 100
      }
    },

    zbrojiIznos2 () {
      var iznos2 = 0
      this.stavke.forEach(i => {
        if (!this.isPovratnaNaknada(i)) {
          // Duplicate logic from getIznos2 to get numeric value
          const cijenaSPdv = (i.item && i.item.kalkulacija && i.item.kalkulacija.cijena && i.item.kalkulacija.cijena.cijena_s_pdv) || 0
          const cijenaSPdvEur = cijenaSPdv / 100

          let povratnaNaknada = 0
          if (i.item && i.item.item && i.item.item.naknade && i.item.item.naknade.povratna && i.item.item.naknade.povratna.amount) {
            povratnaNaknada = i.item.item.naknade.povratna.amount / 100
          }

          const cijenaNakonNaknade = cijenaSPdvEur - povratnaNaknada

          let pdvStopa = 0
          if (i.item && i.item.item && i.item.item.tax_group_object && i.item.item.tax_group_object.pdv_rate) {
            pdvStopa = i.item.item.tax_group_object.pdv_rate
          } else if (i.item && i.item.kalkulacija && i.item.kalkulacija.cijena && i.item.kalkulacija.cijena.pdv_stopa) {
            pdvStopa = i.item.kalkulacija.cijena.pdv_stopa / 100
          }

          const cijenaBezPdv = pdvStopa > 0 ? cijenaNakonNaknade / (1 + pdvStopa / 100) : cijenaNakonNaknade
          const kolicina = (i.item && i.item.kalkulacija && i.item.kalkulacija.kolicina) || 0
          const iznos = cijenaBezPdv * (kolicina / 1000)

          iznos2 += iznos
        }
        // NE dodajemo povratnu naknadu - ova metoda je samo za SVEUKUPNO
      })

      if (this.viewType === 'pdf') {
        return this.formatCurrency(iznos2, 1)
      } else {
        return iznos2 / 100
      }
    },

    zbrojiPdvIznos () {
      var pdvIznosTotal = 0
      this.stavke.forEach(i => {
        if (!this.isPovratnaNaknada(i)) {
          // Duplicate logic from getPdvIznos to get numeric value
          const cijenaSPdv = (i.item && i.item.kalkulacija && i.item.kalkulacija.cijena && i.item.kalkulacija.cijena.cijena_s_pdv) || 0
          const cijenaSPdvEur = cijenaSPdv / 100

          let povratnaNaknada = 0
          if (i.item && i.item.item && i.item.item.naknade && i.item.item.naknade.povratna && i.item.item.naknade.povratna.amount) {
            povratnaNaknada = i.item.item.naknade.povratna.amount / 100
          }

          const cijenaNakonNaknade = cijenaSPdvEur - povratnaNaknada

          let pdvStopa = 0
          if (i.item && i.item.item && i.item.item.tax_group_object && i.item.item.tax_group_object.pdv_rate) {
            pdvStopa = i.item.item.tax_group_object.pdv_rate
          } else if (i.item && i.item.kalkulacija && i.item.kalkulacija.cijena && i.item.kalkulacija.cijena.pdv_stopa) {
            pdvStopa = i.item.kalkulacija.cijena.pdv_stopa / 100
          }

          const cijenaBezPdv = pdvStopa > 0 ? cijenaNakonNaknade / (1 + pdvStopa / 100) : cijenaNakonNaknade
          const kolicina = (i.item && i.item.kalkulacija && i.item.kalkulacija.kolicina) || 0
          const iznosBezPdv = cijenaBezPdv * (kolicina / 1000)
          const pdvIznos = iznosBezPdv * (pdvStopa / 100)

          pdvIznosTotal += pdvIznos
        }
      })

      if (this.viewType === 'pdf') {
        return this.formatCurrency(pdvIznosTotal, 1)
      } else {
        return pdvIznosTotal
      }
    },

    zbrojiNabavnuVrijednost () {
      var nabavnaVrijednost = 0
      this.stavke.forEach(i => {
        if (!this.isPovratnaNaknada(i)) {
          nabavnaVrijednost += (i.item && i.item.kalkulacija && i.item.kalkulacija.nabavna_cijena && i.item.kalkulacija.nabavna_cijena.nabavna_vrijednost) || 0
        }
      })

      if (this.viewType === 'pdf') {
        return this.formatCurrency(nabavnaVrijednost / 100, 1)
      } else {
        return nabavnaVrijednost / 100
      }
    },

    zbrojiMarzu () {
      var marza = 0
      this.stavke.forEach(i => {
        if (!this.isPovratnaNaknada(i)) {
          marza += (i.item && i.item.kalkulacija && i.item.kalkulacija.marza_iznos) || 0
        }
      })

      if (this.viewType === 'pdf') {
        return this.formatCurrency(marza / 100, 1)
      } else {
        return marza / 100
      }
    },

    zbrojiIznosSPdv () {
      var iznosSPdvTotal = 0
      this.stavke.forEach(i => {
        if (!this.isPovratnaNaknada(i)) {
          // Duplicate logic from getIznosSPdv to get numeric value
          const cijenaSPdv = (i.item && i.item.kalkulacija && i.item.kalkulacija.cijena && i.item.kalkulacija.cijena.cijena_s_pdv) || 0
          const cijenaSPdvEur = cijenaSPdv / 100

          let povratnaNaknada = 0
          if (i.item && i.item.item && i.item.item.naknade && i.item.item.naknade.povratna && i.item.item.naknade.povratna.amount) {
            povratnaNaknada = i.item.item.naknade.povratna.amount / 100
          }

          const cijenaNakonNaknade = cijenaSPdvEur - povratnaNaknada

          let pdvStopa = 0
          if (i.item && i.item.item && i.item.item.tax_group_object && i.item.item.tax_group_object.pdv_rate) {
            pdvStopa = i.item.item.tax_group_object.pdv_rate
          } else if (i.item && i.item.kalkulacija && i.item.kalkulacija.cijena && i.item.kalkulacija.cijena.pdv_stopa) {
            pdvStopa = i.item.kalkulacija.cijena.pdv_stopa / 100
          }

          const cijenaBezPdv = pdvStopa > 0 ? cijenaNakonNaknade / (1 + pdvStopa / 100) : cijenaNakonNaknade
          const kolicina = (i.item && i.item.kalkulacija && i.item.kalkulacija.kolicina) || 0
          const iznosBezPdv = cijenaBezPdv * (kolicina / 1000)
          const pdvIznos = iznosBezPdv * (pdvStopa / 100)
          const iznosSPdv = iznosBezPdv + pdvIznos

          iznosSPdvTotal += iznosSPdv
        }
        // Ne dodajemo povratnu naknadu u iznos s PDV
      })

      if (this.viewType === 'pdf') {
        return this.formatCurrency(iznosSPdvTotal, 1)
      } else {
        return iznosSPdvTotal
      }
    },

    getUkupnaPovratnaNaknada () {
      var ukupnaNaknada = 0
      this.povratnaNaknadaStavke.forEach(i => {
        const iznos = (i.item && i.item.warehouse_data && i.item.warehouse_data.value) || 0
        ukupnaNaknada += iznos / 10000
      })

      if (this.viewType === 'pdf') {
        return this.formatCurrency(ukupnaNaknada, 1)
      } else {
        return ukupnaNaknada
      }
    },

    totalIznos2 () {
      // TOTAL = SVEUKUPNO + Povratna naknada
      // Duplicate logic to calculate numeric values
      var total = 0

      // Add regular items
      this.stavke.forEach(i => {
        if (!this.isPovratnaNaknada(i)) {
          const cijenaSPdv = (i.item && i.item.kalkulacija && i.item.kalkulacija.cijena && i.item.kalkulacija.cijena.cijena_s_pdv) || 0
          const cijenaSPdvEur = cijenaSPdv / 100

          let povratnaNaknada = 0
          if (i.item && i.item.item && i.item.item.naknade && i.item.item.naknade.povratna && i.item.item.naknade.povratna.amount) {
            povratnaNaknada = i.item.item.naknade.povratna.amount / 100
          }

          const cijenaNakonNaknade = cijenaSPdvEur - povratnaNaknada

          let pdvStopa = 0
          if (i.item && i.item.item && i.item.item.tax_group_object && i.item.item.tax_group_object.pdv_rate) {
            pdvStopa = i.item.item.tax_group_object.pdv_rate
          } else if (i.item && i.item.kalkulacija && i.item.kalkulacija.cijena && i.item.kalkulacija.cijena.pdv_stopa) {
            pdvStopa = i.item.kalkulacija.cijena.pdv_stopa / 100
          }

          const cijenaBezPdv = pdvStopa > 0 ? cijenaNakonNaknade / (1 + pdvStopa / 100) : cijenaNakonNaknade
          const kolicina = (i.item && i.item.kalkulacija && i.item.kalkulacija.kolicina) || 0
          const iznos = cijenaBezPdv * (kolicina / 1000)

          total += iznos
        } else {
          // Add povratna naknada
          const iznos = (i.item && i.item.warehouse_data && i.item.warehouse_data.value) || 0
          total += iznos / 10000
        }
      })

      if (this.viewType === 'pdf') {
        return this.formatCurrency(total, 1)
      } else {
        return total
      }
    },

    totalIznosSPdv () {
      // TOTAL Iznos s PDV = SVEUKUPNO Iznos s PDV + Povratna naknada
      // (povratna naknada nema PDV, pa je njen iznos s PDV = iznos bez PDV)
      var total = 0

      // Add regular items
      this.stavke.forEach(i => {
        if (!this.isPovratnaNaknada(i)) {
          const cijenaSPdv = (i.item && i.item.kalkulacija && i.item.kalkulacija.cijena && i.item.kalkulacija.cijena.cijena_s_pdv) || 0
          const cijenaSPdvEur = cijenaSPdv / 100

          let povratnaNaknada = 0
          if (i.item && i.item.item && i.item.item.naknade && i.item.item.naknade.povratna && i.item.item.naknade.povratna.amount) {
            povratnaNaknada = i.item.item.naknade.povratna.amount / 100
          }

          const cijenaNakonNaknade = cijenaSPdvEur - povratnaNaknada

          let pdvStopa = 0
          if (i.item && i.item.item && i.item.item.tax_group_object && i.item.item.tax_group_object.pdv_rate) {
            pdvStopa = i.item.item.tax_group_object.pdv_rate
          } else if (i.item && i.item.kalkulacija && i.item.kalkulacija.cijena && i.item.kalkulacija.cijena.pdv_stopa) {
            pdvStopa = i.item.kalkulacija.cijena.pdv_stopa / 100
          }

          const cijenaBezPdv = pdvStopa > 0 ? cijenaNakonNaknade / (1 + pdvStopa / 100) : cijenaNakonNaknade
          const kolicina = (i.item && i.item.kalkulacija && i.item.kalkulacija.kolicina) || 0
          const iznosBezPdv = cijenaBezPdv * (kolicina / 1000)
          const pdvIznos = iznosBezPdv * (pdvStopa / 100)
          const iznosSPdv = iznosBezPdv + pdvIznos

          total += iznosSPdv
        } else {
          // Add povratna naknada (nema PDV, tako da je iznos s PDV = iznos bez PDV)
          const iznos = (i.item && i.item.warehouse_data && i.item.warehouse_data.value) || 0
          total += iznos / 10000
        }
      })

      if (this.viewType === 'pdf') {
        return this.formatCurrency(total, 1)
      } else {
        return total
      }
    },

    formatCurrency (item, divider = 100) {
      return this.$options.filters
        .money(item, divider, this.currency)
        .replace('€', '')
    },

    // Helper metode za dohvaćanje podataka - koristi warehouse_data za povratnu naknadu
    isPovratnaNaknada (i) {
      return i.id === '-1' || (i.item && i.item.item && i.item.item.id === '-1')
    },

    getPovratnaNaknadaNaziv (i) {
      if (i.item && i.item.item && i.item.item.name) {
        return i.item.item.name
      }
      if (i.name) {
        return i.name
      }
      return 'Povratna naknada'
    },

    getKolicina (i) {
      if (this.isPovratnaNaknada(i)) {
        const kol = (i.item && i.item.warehouse_data && i.item.warehouse_data.received_amount_quantity) || 0
        return this.viewType === 'pdf' ? this.formatCurrency(kol / 1000, 1) : kol / 1000
      }
      const kol = (i.item && i.item.kalkulacija && i.item.kalkulacija.kolicina) || 0
      return this.viewType === 'pdf' ? this.formatCurrency(kol / 1000, 1) : kol / 1000
    },

    getNabavnaCijena (i) {
      if (this.isPovratnaNaknada(i)) {
        const cijena = (i.item && i.item.warehouse_data && i.item.warehouse_data.purchase_price) || 0
        return this.viewType === 'pdf' ? this.formatCurrency(cijena / 100, 1) : cijena / 100
      }
      const cijena = (i.item && i.item.kalkulacija && i.item.kalkulacija.nabavna_cijena && i.item.kalkulacija.nabavna_cijena.nabavna_cijena) || 0
      return this.viewType === 'pdf' ? this.formatCurrency(cijena / 100, 1) : cijena / 100
    },

    getIznos (i) {
      if (this.isPovratnaNaknada(i)) {
        const iznos = (i.item && i.item.warehouse_data && i.item.warehouse_data.value) || 0
        return this.viewType === 'pdf' ? this.formatCurrency(iznos / 10000, 1) : iznos / 10000
      }
      const iznos = (i.item && i.item.kalkulacija && i.item.kalkulacija.nabavna_cijena && i.item.kalkulacija.nabavna_cijena.iznos) || 0
      return this.viewType === 'pdf' ? this.formatCurrency(iznos / 100, 1) : iznos / 100
    },

    getRabatStopa (i) {
      if (this.isPovratnaNaknada(i)) return this.viewType === 'pdf' ? this.formatCurrency(0, 1) : 0
      const rabat = (i.item && i.item.kalkulacija && i.item.kalkulacija.nabavna_cijena && i.item.kalkulacija.nabavna_cijena.rabat_stopa) || 0
      return this.viewType === 'pdf' ? this.formatCurrency(rabat / 100, 1) : rabat / 100
    },

    getRabatIznos (i) {
      if (this.isPovratnaNaknada(i)) return this.viewType === 'pdf' ? this.formatCurrency(0, 1) : 0
      const iznos = (i.item && i.item.kalkulacija && i.item.kalkulacija.nabavna_cijena && i.item.kalkulacija.nabavna_cijena.rabat_iznos) || 0
      return this.viewType === 'pdf' ? this.formatCurrency(iznos / 100, 1) : iznos / 100
    },

    getNabavnaVrijednost (i) {
      if (this.isPovratnaNaknada(i)) {
        const vrij = (i.item && i.item.warehouse_data && i.item.warehouse_data.value) || 0
        return this.viewType === 'pdf' ? this.formatCurrency(vrij / 10000, 1) : vrij / 10000
      }
      const vrij = (i.item && i.item.kalkulacija && i.item.kalkulacija.nabavna_cijena && i.item.kalkulacija.nabavna_cijena.nabavna_vrijednost) || 0
      return this.viewType === 'pdf' ? this.formatCurrency(vrij / 100, 1) : vrij / 100
    },

    getMarza (i) {
      if (this.isPovratnaNaknada(i)) return this.viewType === 'pdf' ? this.formatCurrency(0, 1) : 0
      const marza = (i.item && i.item.kalkulacija && i.item.kalkulacija.marza) || 0
      return this.viewType === 'pdf' ? this.formatCurrency(marza / 100, 1) : marza / 100
    },

    getMarzaIznos (i) {
      if (this.isPovratnaNaknada(i)) return this.viewType === 'pdf' ? this.formatCurrency(0, 1) : 0
      const iznos = (i.item && i.item.kalkulacija && i.item.kalkulacija.marza_iznos) || 0
      return this.viewType === 'pdf' ? this.formatCurrency(iznos / 100, 1) : iznos / 100
    },

    getCijena (i) {
      if (this.isPovratnaNaknada(i)) {
        const cijena = (i.item && i.item.warehouse_data && i.item.warehouse_data.purchase_price) || 0
        return this.viewType === 'pdf' ? this.formatCurrency(cijena / 100, 1) : cijena / 100
      }

      // 1. Uzmi maloprodajnu cijenu s PDV-om (cijena_s_pdv je u centima)
      const cijenaSPdv = (i.item && i.item.kalkulacija && i.item.kalkulacija.cijena && i.item.kalkulacija.cijena.cijena_s_pdv) || 0
      const cijenaSPdvEur = cijenaSPdv / 100

      // 2. Dohvati povratnu naknadu iz i.item.item.naknade (amount je u centima)
      let povratnaNaknada = 0
      if (i.item && i.item.item && i.item.item.naknade && i.item.item.naknade.povratna && i.item.item.naknade.povratna.amount) {
        povratnaNaknada = i.item.item.naknade.povratna.amount / 100
      }

      // 3. Oduzmi povratnu naknadu od cijene s PDV-om
      const cijenaNakonNaknade = cijenaSPdvEur - povratnaNaknada

      // 4. Dohvati PDV stopu iz i.item.item.tax_group_object
      let pdvStopa = 0
      if (i.item && i.item.item && i.item.item.tax_group_object && i.item.item.tax_group_object.pdv_rate) {
        pdvStopa = i.item.item.tax_group_object.pdv_rate
      } else if (i.item && i.item.kalkulacija && i.item.kalkulacija.cijena && i.item.kalkulacija.cijena.pdv_stopa) {
        pdvStopa = i.item.kalkulacija.cijena.pdv_stopa / 100
      }

      // 5. Odbij PDV da dobiješ cijenu bez PDV-a
      const cijenaBezPdv = pdvStopa > 0 ? cijenaNakonNaknade / (1 + pdvStopa / 100) : cijenaNakonNaknade

      return this.viewType === 'pdf' ? this.formatCurrency(cijenaBezPdv, 1) : cijenaBezPdv
    },

    getIznos2 (i) {
      if (this.isPovratnaNaknada(i)) {
        const iznos = (i.item && i.item.warehouse_data && i.item.warehouse_data.value) || 0
        return this.viewType === 'pdf' ? this.formatCurrency(iznos / 10000, 1) : iznos / 10000
      }

      // Duplicate logic from getCijena to get numeric value
      const cijenaSPdv = (i.item && i.item.kalkulacija && i.item.kalkulacija.cijena && i.item.kalkulacija.cijena.cijena_s_pdv) || 0
      const cijenaSPdvEur = cijenaSPdv / 100

      let povratnaNaknada = 0
      if (i.item && i.item.item && i.item.item.naknade && i.item.item.naknade.povratna && i.item.item.naknade.povratna.amount) {
        povratnaNaknada = i.item.item.naknade.povratna.amount / 100
      }

      const cijenaNakonNaknade = cijenaSPdvEur - povratnaNaknada

      let pdvStopa = 0
      if (i.item && i.item.item && i.item.item.tax_group_object && i.item.item.tax_group_object.pdv_rate) {
        pdvStopa = i.item.item.tax_group_object.pdv_rate
      } else if (i.item && i.item.kalkulacija && i.item.kalkulacija.cijena && i.item.kalkulacija.cijena.pdv_stopa) {
        pdvStopa = i.item.kalkulacija.cijena.pdv_stopa / 100
      }

      const cijenaBezPdv = pdvStopa > 0 ? cijenaNakonNaknade / (1 + pdvStopa / 100) : cijenaNakonNaknade

      // Iznos = Cijena bez PDV × Količina
      const kolicina = (i.item && i.item.kalkulacija && i.item.kalkulacija.kolicina) || 0
      const iznos = cijenaBezPdv * (kolicina / 1000)
      return this.viewType === 'pdf' ? this.formatCurrency(iznos, 1) : iznos
    },

    getPdvStopa (i) {
      if (this.isPovratnaNaknada(i)) return this.viewType === 'pdf' ? this.formatCurrency(0, 1) : 0
      const stopa = (i.item && i.item.kalkulacija && i.item.kalkulacija.cijena && i.item.kalkulacija.cijena.pdv_stopa) || 0
      return this.viewType === 'pdf' ? this.formatCurrency(stopa / 100, 1) : stopa / 100
    },

    getPdvIznos (i) {
      if (this.isPovratnaNaknada(i)) return this.viewType === 'pdf' ? this.formatCurrency(0, 1) : 0

      // Duplicate logic to get numeric values
      const cijenaSPdv = (i.item && i.item.kalkulacija && i.item.kalkulacija.cijena && i.item.kalkulacija.cijena.cijena_s_pdv) || 0
      const cijenaSPdvEur = cijenaSPdv / 100

      let povratnaNaknada = 0
      if (i.item && i.item.item && i.item.item.naknade && i.item.item.naknade.povratna && i.item.item.naknade.povratna.amount) {
        povratnaNaknada = i.item.item.naknade.povratna.amount / 100
      }

      const cijenaNakonNaknade = cijenaSPdvEur - povratnaNaknada

      let pdvStopa = 0
      if (i.item && i.item.item && i.item.item.tax_group_object && i.item.item.tax_group_object.pdv_rate) {
        pdvStopa = i.item.item.tax_group_object.pdv_rate
      } else if (i.item && i.item.kalkulacija && i.item.kalkulacija.cijena && i.item.kalkulacija.cijena.pdv_stopa) {
        pdvStopa = i.item.kalkulacija.cijena.pdv_stopa / 100
      }

      const cijenaBezPdv = pdvStopa > 0 ? cijenaNakonNaknade / (1 + pdvStopa / 100) : cijenaNakonNaknade
      const kolicina = (i.item && i.item.kalkulacija && i.item.kalkulacija.kolicina) || 0
      const iznosBezPdv = cijenaBezPdv * (kolicina / 1000)

      // PDV iznos = Iznos bez PDV × PDV stopa / 100
      const pdvIznos = iznosBezPdv * (pdvStopa / 100)
      return this.viewType === 'pdf' ? this.formatCurrency(pdvIznos, 1) : pdvIznos
    },

    getIznosSPdv (i) {
      if (this.isPovratnaNaknada(i)) {
        const iznos = (i.item && i.item.warehouse_data && i.item.warehouse_data.value) || 0
        return this.viewType === 'pdf' ? this.formatCurrency(iznos / 10000, 1) : iznos / 10000
      }

      // Duplicate logic to get numeric values
      const cijenaSPdv = (i.item && i.item.kalkulacija && i.item.kalkulacija.cijena && i.item.kalkulacija.cijena.cijena_s_pdv) || 0
      const cijenaSPdvEur = cijenaSPdv / 100

      let povratnaNaknada = 0
      if (i.item && i.item.item && i.item.item.naknade && i.item.item.naknade.povratna && i.item.item.naknade.povratna.amount) {
        povratnaNaknada = i.item.item.naknade.povratna.amount / 100
      }

      const cijenaNakonNaknade = cijenaSPdvEur - povratnaNaknada

      let pdvStopa = 0
      if (i.item && i.item.item && i.item.item.tax_group_object && i.item.item.tax_group_object.pdv_rate) {
        pdvStopa = i.item.item.tax_group_object.pdv_rate
      } else if (i.item && i.item.kalkulacija && i.item.kalkulacija.cijena && i.item.kalkulacija.cijena.pdv_stopa) {
        pdvStopa = i.item.kalkulacija.cijena.pdv_stopa / 100
      }

      const cijenaBezPdv = pdvStopa > 0 ? cijenaNakonNaknade / (1 + pdvStopa / 100) : cijenaNakonNaknade
      const kolicina = (i.item && i.item.kalkulacija && i.item.kalkulacija.kolicina) || 0
      const iznosBezPdv = cijenaBezPdv * (kolicina / 1000)
      const pdvIznos = iznosBezPdv * (pdvStopa / 100)

      // Iznos s PDV = Iznos bez PDV + PDV iznos
      const iznosSPdv = iznosBezPdv + pdvIznos
      return this.viewType === 'pdf' ? this.formatCurrency(iznosSPdv, 1) : iznosSPdv
    },

    getCijenaSPdv (i) {
      if (this.isPovratnaNaknada(i)) {
        const cijena = (i.item && i.item.warehouse_data && i.item.warehouse_data.purchase_price) || 0
        return this.viewType === 'pdf' ? this.formatCurrency(cijena / 100, 1) : cijena / 100
      }

      // 1. Uzmi maloprodajnu cijenu s PDV-om (cijena_s_pdv je u centima)
      const cijenaSPdv = (i.item && i.item.kalkulacija && i.item.kalkulacija.cijena && i.item.kalkulacija.cijena.cijena_s_pdv) || 0
      const cijenaSPdvEur = cijenaSPdv / 100

      // 2. Dohvati povratnu naknadu iz i.item.item.naknade (amount je u centima)
      let povratnaNaknada = 0
      if (i.item && i.item.item && i.item.item.naknade && i.item.item.naknade.povratna && i.item.item.naknade.povratna.amount) {
        povratnaNaknada = i.item.item.naknade.povratna.amount / 100
      }

      // 3. Oduzmi povratnu naknadu od cijene s PDV-om
      const cijenaSPdvNakonNaknade = cijenaSPdvEur - povratnaNaknada

      return this.viewType === 'pdf' ? this.formatCurrency(cijenaSPdvNakonNaknade, 1) : cijenaSPdvNakonNaknade
    }
  }
}

</script>
<style scoped>
.enabledbutton {
  background-color: #2c97c5 !important;
  border-color: #2c97c5 !important;
  color: white;
  font-weight: 700;
}

.naslov {
  background-color: #d3d3d3;
  border: 0px solid black;
}

.selectedrow-456 {
  background-color: #2c97c5 !important;
  border-color: #2c97c5 !important;
  color: white;
  font-weight: 700;
}

.divider-line {
  height: 1px !important;
  line-height: 0 !important;
  font-size: 0 !important;
}

.divider-line td {
  padding: 0 !important;
  margin: 0 !important;
  height: 1px !important;
  line-height: 0 !important;
  border-top: 1px solid #000;
  font-size: 0 !important;
}

/* Optional: style for the summary row */
.summary-row {
  font-weight: bold;
}

.createDelivery>>>.vm--modal {
  border-radius: 25px !important;
}

.editDelivery>>>.vm--modal {
  border-radius: 25px !important;
}
</style>
